export default {
  CLICK: "click",
  HOVER: "hover",
};
